import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29,11.71H27V8a1,1,0,0,0-1-1H3A1,1,0,0,0,2,8V23a1,1,0,0,0,1,1H26a1,1,0,0,0,1-1V19.29h2a1,1,0,0,0,1-1V12.71A1,1,0,0,0,29,11.71ZM25,22H4V9H25V22Zm3-4.71H27V13.71h1Z"/><rect x="6" y="11" width="2" height="9"/>';
export var BatteryLowOutlineSVG = function BatteryLowOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BatteryLowOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BatteryLowOutlineSVG);